import React from 'react';
import { Typography } from '@mui/material';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';
import { calculateElapsedDateTime } from '@src/utils/date';
import { useTranslation } from 'react-i18next';
import { StyledIconButton, StyledProjectListItem } from './index.style';

const ProjectListItem = ({ project }) => {
  const { t } = useTranslation();
  return (
    <StyledProjectListItem>
      <div className="item-content-wrapper">
        <div className="item-title-wrapper">
          <div className="item-title-icon">
            <LibraryBooksIcon />
          </div>
          <div>
            <Typography className="item-title">{project.title}</Typography>
            <Typography className="item-created-at">
              {calculateElapsedDateTime(project.createdAt, t)}
            </Typography>
          </div>
        </div>
        <div>
          <StyledIconButton
            data-id="view-other-project-actions"
            height="40px"
            width="40px"
            padding="12px"
          >
            <MoreVertOutlinedIcon
              className="icon-morevert"
              color="rgba(30, 22, 78, 0.64)"
            />
          </StyledIconButton>
        </div>
      </div>
    </StyledProjectListItem>
  );
};

export default ProjectListItem;
